import { SubmitMfaFormFooterStyling } from './types';

export const submitMfaFormFooterStyling: SubmitMfaFormFooterStyling = {
  confirmBtn: {
    '& .MuiTypography-root': {
      verticalTrim: 'cap-height',
    },
  },
};
